import { Button } from "@/components/ui/button";
import { Columns2, Columns3, Columns4, RectangleVertical } from "lucide-react";

interface ColumnSelectorProps {
  columns: number;
  onColumnsChange: (columns: number) => void;
  documentColor: string;
}

export function ColumnSelector({ columns, onColumnsChange, documentColor }: ColumnSelectorProps) {
  const columnOptions = [
    { value: 1, icon: RectangleVertical, label: "1 column" },
    { value: 2, icon: Columns2, label: "2 columns" },
    { value: 3, icon: Columns3, label: "3 columns" },
    { value: 4, icon: Columns4, label: "4 columns" },
  ];

  return (
    <div className="w-full flex justify-center py-3">
      <div className="bg-background/95 border border-border rounded-lg p-2 shadow-sm">
        <div className="flex items-center gap-1">
          {columnOptions.map(({ value, icon: Icon, label }) => (
            <Button
              key={value}
              variant={columns === value ? "default" : "ghost"}
              size="sm"
              onClick={() => onColumnsChange(value)}
              className="h-8 w-8 p-0 transition-all duration-200 hover:scale-110 active:scale-95"
              style={
                columns === value
                  ? { backgroundColor: documentColor, color: "white" }
                  : {}
              }
              title={label}
              data-testid={`button-columns-${value}`}
            >
              <Icon className="h-4 w-4" />
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
